<!-- Vue stays dumb: the server resolves and rejects the target account. -->
<template>
  <h4 class="subtitle mb-3 is-size-6 is-small-mobile">{{ titleText }}</h4>

  <div class="field mb-3">
    <label class="label is-small-mobile">User ID or email</label>
    <div class="control">
      <input
        ref="inputRef"
        v-model="target"
        class="input is-small-mobile"
        type="text"
        placeholder="user@example.com or 123"
        @keyup.enter="submit"
      />
    </div>
  </div>

  <p v-if="error" class="help is-danger mb-3">{{ error }}</p>

  <div class="field is-grouped is-justify-content-space-between">
    <div class="control">
      <button class="button is-small-mobile" @click="cancel">Cancel</button>
    </div>
    <div class="control">
      <button
        class="button is-primary is-small-mobile"
        :class="{ 'is-loading': isBusy }"
        :disabled="!canSubmit"
        @click="submit"
      >
        <span>Copy</span>
      </button>
    </div>
  </div>
</template>

<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import { nextTick, onMounted } from "vue";

  const props = defineProps({
    // Recipe search store. Must expose bulkCopyToAccount(targetUser).
    store: { type: Object, required: true },
    // Selection size, for the title only.
    count: { type: Number, required: true },
  });

  const emit = defineEmits(["close", "done"]);

  let target = _ref("");
  let error = _ref("");
  let isBusy = _ref(false);
  const inputRef = _ref(null);

  const titleText = _computed(
    () => `Copy ${props.count} ${props.count === 1 ? "recipe" : "recipes"} to another account`
  );

  const canSubmit = _computed(() => target.value.trim().length > 0 && !isBusy.value);

  onMounted(() => nextTick(() => inputRef.value?.focus()));

  function cancel() {
    emit("close");
  }

  async function submit() {
    if (!canSubmit.value) return;

    isBusy.value = true;
    error.value = "";
    try {
      const message = await props.store.bulkCopyToAccount(target.value.trim());
      emit("done", message);
    } catch (err) {
      error.value = typeof err === "string" ? err : "Failed to start copy";
    }
    isBusy.value = false;
  }
</script>
